
<sm-title-bar pageTitle="Purchased Recharges" >
    <!-- <ng-template #addButton >
      <button mat-flat-button color="accent" (click)="createNewBooking()" *ngIf="selectedValue == '0'">
        Create new booking
        <mat-icon class="material-icons-round" [inline]="true">add_circle</mat-icon>
      </button>
      <mat-icon class="material-icons-round" [inline]="true"
      >refresh</mat-icon>
    </ng-template> -->
  
  </sm-title-bar>
  <div class="chip_cont">
    <mat-chip-listbox aria-label="Fish selection" class="mb-3">
      <mat-chip
       
        [ngClass]="{ selected: selectedValue == '0' }"
        (click)="changeChip('0')"
        >Unused Business Packs
      </mat-chip>
    </mat-chip-listbox>
  
    <mat-chip-listbox aria-label="Fish selection" class="mb-3">
      <mat-chip
       
        [ngClass]="{ selected: selectedValue == '1' }"
        (click)="changeChip('1')"
        >Unused Employee Packs
      </mat-chip>
    </mat-chip-listbox>
    <mat-chip-listbox aria-label="Fish selection" class="mb-3">
      <mat-chip
       
        [ngClass]="{ selected: selectedValue == '2' }"
        (click)="changeChip('2')"
        >Transactions
      </mat-chip>
    </mat-chip-listbox>
  </div>
  
  <mat-card appearance="outlined" *ngIf="visible && !loader">
    <mat-card-header class="justify-content-between align-items-center mb-3">
    </mat-card-header>
    <div class="rounded-3 bg-light">
      <sm-data-table
        [columnHeaders]="tableDisplayColumns"
        [dataSource]="subsData"
        [showPagination]="true"
        [itemsPerPage]="25"
        *ngIf="selectedValue != '2'"
      >
  
      </sm-data-table>
      <sm-data-table
        [columnHeaders]="tableDisplayColumns2"
        [dataSource]="transactionData"
        [showPagination]="true"
        [itemsPerPage]="25"
        *ngIf="selectedValue == '2'"
      >
  
      </sm-data-table>
    </div>
  </mat-card>
  
  <ng-template #menuTemplate let-rowvalue>
      <button mat-menu-item *ngIf="((rowvalue.bookingStatus == 0 || rowvalue.bookingStatus == 1 || rowvalue.bookingStatus == 2) && (rowvalue.customerInfo.hash_id && rowvalue.customerInfo.hash_id != 'null'))" (click)="confirmBooking(rowvalue)">
        <mat-icon class="material-icons-outlined">check_circle</mat-icon>
        <span>Confirm booking</span>
      </button>
      <button mat-menu-item *ngIf="rowvalue.bookingStatus == 0 || rowvalue.bookingStatus == 1 || rowvalue.bookingStatus == 2 || rowvalue.bookingStatus == 7 || rowvalue.bookingStatus == 9 || rowvalue.bookingStatus == 5" (click)="startProcess(rowvalue)">
        <mat-icon class="material-icons-outlined">timer</mat-icon>
        <span>Start process</span>
      </button>
      <button mat-menu-item *ngIf="rowvalue.bookingStatus == 0 || rowvalue.bookingStatus == 1 || rowvalue.bookingStatus == 2 || rowvalue.bookingStatus == 7 || rowvalue.bookingStatus == 9 || rowvalue.bookingStatus == 5" (click)="assignJob(rowvalue)">
        <mat-icon class="material-icons-outlined">assignment_ind</mat-icon>
        <span>Assign job</span>
      </button>
      
      <button mat-menu-item *ngIf="rowvalue.bookingStatus == 3 " (click)="done(rowvalue)">
        <mat-icon class="material-icons-outlined">task_alt</mat-icon>
        <span>Done</span>
      </button>
      <button mat-menu-item *ngIf="rowvalue.bookingStatus == 3 || rowvalue.bookingStatus == 9 || rowvalue.bookingStatus == 4" (click)="customiseBooking(rowvalue)">
        <mat-icon class="material-icons-outlined">tune</mat-icon>
        <span>Customise</span>
      </button>
      <button mat-menu-item *ngIf="rowvalue.bookingStatus == 3 || rowvalue.bookingStatus == 9 || rowvalue.bookingStatus == 4" (click)="reset(rowvalue)">
        <mat-icon class="material-icons-outlined">restart_alt</mat-icon>
        <span>Reset to new</span>
      </button>
      <button mat-menu-item *ngIf="rowvalue.bookingStatus == 0 || rowvalue.bookingStatus == 1 || rowvalue.bookingStatus == 2 || rowvalue.bookingStatus == 7 || rowvalue.bookingStatus == 3 || rowvalue.bookingStatus == 9 || rowvalue.bookingStatus == 4 || rowvalue.bookingStatus == 8 || rowvalue.bookingStatus == 5" (click)="bookingDetails(rowvalue)">
        <mat-icon class="material-icons-outlined">info</mat-icon>
        <span>Booking Details</span>
      </button>
      <button mat-menu-item *ngIf="rowvalue.bookingStatus == 4" (click)="openInvoice(rowvalue)">
        <mat-icon class="material-icons-outlined">receipt_long</mat-icon>
        <span>Invoice</span>
      </button>
      <button mat-menu-item *ngIf="((rowvalue.bookingStatus == 0 || rowvalue.bookingStatus == 1 || rowvalue.bookingStatus == 2 || rowvalue.bookingStatus == 5) && (rowvalue.customerInfo.hash_id && rowvalue.customerInfo.hash_id != 'null'))" (click)="cancelBooking(rowvalue)">
        <mat-icon class="material-icons-outlined">cancel</mat-icon>
        <span>Cancel booking</span>
      </button>
      
    </ng-template>
  